import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
export var When = function When(_ref) {
  var children = _ref.children,
      value = _ref.value;
  if (!value) return /*#__PURE__*/_jsx(Fragment, {});
  return typeof children === 'function' ? children() : children;
};